<template>
    <n-config-provider :theme-overrides="getThemeOverrides" :locale="zhCN" :date-locale="dateZhCN">
        <n-message-provider>
            <router-view />
        </n-message-provider>
    </n-config-provider>
</template>

<script lang="ts">
import { type GlobalThemeOverrides, zhCN, dateZhCN } from 'naive-ui';
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'App',
    setup() {
        const getThemeOverrides = computed(() => {
            const themeOverrides: GlobalThemeOverrides = {
                common: {
                    primaryColor: '#2d8cf0',
                    primaryColorHover: '#3c9bff',
                    primaryColorPressed: '#3c9bff',
                },
                LoadingBar: {
                    colorLoading: '#2d8cf0',
                },
            };
            const t = {
                color: '#fff',
                textColor: '#000',
            };
            themeOverrides.Tooltip = t;
            const t1 = {
                color: '#FAF9F8',
            };
            themeOverrides.Layout = t1;
            return themeOverrides;
        });

        return {
            getThemeOverrides,
            zhCN,
            dateZhCN,
        };
    },
});
</script>

<style lang="less">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    box-sizing: border-box;
}
</style>
